ListComponent = require 'views/enterprise/dashboard/list-component'
SearchComponent = require 'views/enterprise/dashboard/search-component'
React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_popover')
_ = require('underscore')

COLLAPSED_LIST_LENGTH = 5

module.exports = class extends React.Component
  constructor: (props) ->
    super(props)

    @state = {
      isCollapsed: true
      searchMatches: @props.items
    }

  paginatedItems: =>
    if @state.isCollapsed
      if @props.collapsedListLength
        _.first(@state.searchMatches, @props.collapsedListLength)
      else
        _.first(@state.searchMatches, COLLAPSED_LIST_LENGTH)
    else
      @state.searchMatches

  onSearchTermChange: (term) =>
    @setState searchMatches: _.filter @props.items, (item) ->
      item.isSearchMatch(term)

  render: t.renderable ->
    collapsedListLength = COLLAPSED_LIST_LENGTH
    if @props.collapsedListLength
      collapsedListLength = @props.collapsedListLength

    t.div =>
      if @props.items.length > collapsedListLength
        t.addElement React.createElement SearchComponent,
          onChange: _.debounce(@onSearchTermChange, 300)
          placeholder: t.l(['search', @props.modelName])

      if @props.buttonData?
        t.addElement React.createElement @props.buttonData.componentClass,
          onClick: @props.buttonData.onClick

      t.div =>
        t.addElement React.createElement ListComponent,
          items: @paginatedItems()
          itemComponent: @props.itemComponent
          itemEventHandlers: @props.itemEventHandlers
          itemInlineButtons: @props.itemInlineButtons
          isPopOver: true

      return unless @state.searchMatches.length > collapsedListLength

      t.div =>
        t.a '.quiet-button',
          href: "#"
          style: { marginTop: '8px' }
          onClick: =>
            @setState(isCollapsed: !@state.isCollapsed)
        , =>
          t.span =>
            if @state.isCollapsed
              t.format ['show-other', @props.modelName]
            else
              t.format ['hide-other', @props.modelName]



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/single-list-popover-component.coffee